var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navigationList.length > 1)?_c('div',{staticClass:"left-nav"},[_c('ul',_vm._l((_vm.navigationList),function(route){return _c('li',{key:route.name},[_c('router-link',{class:{
          'nav-active': _vm.isActive(route),
          group: route.meta.new_group,
        },attrs:{"title":_vm.$t(route.meta.title),"to":route.path,"active-class":"","exact-active-class":""}},[_vm._v(" "+_vm._s(_vm.$t(route.meta.title))+" ")])],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }